import { store } from "@store/StoreConfig";
import { Translation } from "react-i18next";
import { arabicFont } from "./arabicFont";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
const MySwal = withReactContent(Swal);
import ReactPaginate from "react-paginate";
import Avatar from "@components/avatar";
import jsPDF from "jspdf";
import "jspdf-autotable";

export const emptyError = () => (dispatch) => {
  dispatch({
    type: "EMPTY_ERROR",
  });
};

export const createFormData = (_array) => {
  const formData = new FormData();
  const data = [];
  for (let i = 0; i < _array.length; i++) {
    formData.append("data[]", _array[i]);
  }
  return formData;
};

export const handleInfo = (a, b, c, d) => {
  return MySwal.fire({
    title: a,
    html: (
      <div>
        <p className="text-info">
          <Translation>{(t) => t("Total")}</Translation>: {b}
        </p>
        <br />
        <p className="text-success">
          <Translation>{(t) => t("Success")}</Translation>: {c}
        </p>
        <br />
        <p className="text-danger">
          <Translation>{(t) => t("Failed")}</Translation>: {d}
        </p>
      </div>
    ),
    icon: "info",
    customClass: {
      confirmButton: "btn btn-primary",
    },
    buttonsStyling: false,
    timer: 3000,
  });
};
export const handleSuccess = (a, b, c) => {
  return MySwal.fire({
    title: a,
    html: (
      <div>
        <p className="text-info">
          <Translation>{(t) => t("Total")}</Translation>: {b}
        </p>
        <br />
        <p className="text-success">
          <Translation>{(t) => t("Success")}</Translation>: {c}
        </p>
      </div>
    ),
    icon: "success",
    customClass: {
      confirmButton: "btn btn-primary",
    },
    buttonsStyling: false,
    timer: 10000,
  });
};
export const handleError = (a, b, c) => {
  return MySwal.fire({
    title: a,
    html: (
      <div>
        <p className="text-info">
          <Translation>{(t) => t("Total")}</Translation>: {b}
        </p>
        <br />
        <p className="text-danger">
          <Translation>{(t) => t("Failed")}</Translation>: {c}
        </p>
      </div>
    ),
    icon: "error",
    customClass: {
      confirmButton: "btn btn-primary",
    },
    buttonsStyling: false,
    timer: 3000,
  });
};

export const handleSuccessOne = (a, handleNavigate = () => {}) => {
  return MySwal.fire({
    title: a,
    icon: "success",
    customClass: {
      confirmButton: "btn btn-primary",
    },
    buttonsStyling: false,
    timer: 3000,
  }).then((result) => {
    if (result.isConfirmed || result.dismiss === Swal.DismissReason.timer) {
      handleNavigate();
    }
  });
};
export const handleErrorOne = (a) => {
  return MySwal.fire({
    title: a,
    icon: "error",
    customClass: {
      confirmButton: "btn btn-primary",
    },
    buttonsStyling: false,
    timer: 3000,
  });
};

export const handleConfirmCancelInvite = (func, role) => {
  return MySwal.fire({
    title: <Translation>{(t) => t("invite user")}</Translation>,
    html: (
      <Translation>
        {(t) => t("you want to invite this user as ") + role}
      </Translation>
    ),
    icon: "info",
    showCancelButton: true,
    confirmButtonText: <Translation>{(t) => t("confirm")}</Translation>,
    cancelButtonText: <Translation>{(t) => t("Cancel")}</Translation>,
    customClass: {
      confirmButton: "btn btn-primary",
      cancelButton: "btn btn-danger ms-1",
    },
    buttonsStyling: false,
  }).then((result) => {
    if (result.value) {
      store.dispatch(func);
    } else if (result.dismiss === MySwal.DismissReason.cancel) {
      MySwal.fire({
        title: <Translation>{(t) => t("Cancelled")}</Translation>,
        html: <Translation>{(t) => t("Your data is safe :)")}</Translation>,
        icon: "error",
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    }
  });
};

export const handleConfirmCancel = (func) => {
  return MySwal.fire({
    title: <Translation>{(t) => t("Are you sure?")}</Translation>,
    html: (
      <Translation>{(t) => t("You won't be able to revert this!")}</Translation>
    ),
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: <Translation>{(t) => t("Yes, delete it!")}</Translation>,
    cancelButtonText: <Translation>{(t) => t("Cancel")}</Translation>,
    customClass: {
      confirmButton: "btn btn-primary",
      cancelButton: "btn btn-danger ms-1",
    },
    buttonsStyling: false,
  }).then((result) => {
    if (result.value) {
      store.dispatch(func);
    } else if (result.dismiss === MySwal.DismissReason.cancel) {
      MySwal.fire({
        title: <Translation>{(t) => t("Cancelled")}</Translation>,
        html: <Translation>{(t) => t("Your data is safe :)")}</Translation>,
        icon: "error",
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    }
  });
};
export const handleConfirmCancelRestore = (func) => {
  return MySwal.fire({
    title: <Translation>{(t) => t("Are you sure?")}</Translation>,
    html: (
      <Translation>{(t) => t("You won't be able to revert this!")}</Translation>
    ),
    icon: "info",
    showCancelButton: true,
    confirmButtonText: (
      <Translation>{(t) => t("Yes, restore it!")}</Translation>
    ),
    cancelButtonText: <Translation>{(t) => t("Cancel")}</Translation>,
    customClass: {
      confirmButton: "btn btn-primary",
      cancelButton: "btn btn-danger ms-1",
    },
    buttonsStyling: false,
  }).then((result) => {
    if (result.value) {
      store.dispatch(func);
    } else if (result.dismiss === MySwal.DismissReason.cancel) {
      MySwal.fire({
        title: <Translation>{(t) => t("Cancelled")}</Translation>,
        html: <Translation>{(t) => t("Your data is safe :)")}</Translation>,
        icon: "error",
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    }
  });
};
export const handleConfirmRestart = async (func) => {
  return MySwal.fire({
    title: <Translation>{(t) => t("Are you sure?")}</Translation>,
    html: (
      <Translation>{(t) => t("You won't be able to revert this!")}</Translation>
    ),
    icon: "info",
    showCancelButton: true,
    confirmButtonText: <Translation>{(t) => t("Yes, reload it!")}</Translation>,
    cancelButtonText: <Translation>{(t) => t("Cancel")}</Translation>,
    customClass: {
      confirmButton: "btn btn-primary",
      cancelButton: "btn btn-danger ms-1",
    },
    buttonsStyling: false,
  }).then((result) => {
    if (result.value) {
      store.dispatch(func);
    } else if (result.dismiss === MySwal.DismissReason.cancel) {
      MySwal.fire({
        title: <Translation>{(t) => t("Cancelled")}</Translation>,
        html: <Translation>{(t) => t("Your data is safe :)")}</Translation>,
        icon: "error",
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    }
  });
};
export const secondsToTime = (e) => {
  var h = Math.floor(e / 3600)
      .toString()
      .padStart(2, "0"),
    m = Math.floor((e % 3600) / 60)
      .toString()
      .padStart(2, "0"),
    s = Math.floor(e % 60)
      .toString()
      .padStart(2, "0");

  return h + ":" + m + ":" + s;
};
export const startCountdown = (duration_sec) => {
  let counter = duration_sec - 1;
  let display = document.querySelector("#time");

  const interval = setInterval(() => {
    function pad(n, z) {
      z = z || 2;
      return ("00" + n).slice(-z);
    }
    if (counter < 0) {
      clearInterval(interval);
    } else {
      display.textContent = secondsToTime(counter--);
    }
  }, 1000);
};
export const msToTime = (s) => {
  var ms = s % 1000;
  s = (s - ms) / 1000;
  var secs = (s % 60).toString().padStart(2, "0");
  s = (s - secs) / 60;
  var mins = (s % 60).toString().padStart(2, "0");
  var hrs = ((s - mins) / 60).toString().padStart(2, "0");

  return hrs + ":" + mins + ":" + secs;
};
export const progressBarTimer = (timeleft, timetotal, $element) => {
  var progressBarWidth = (timeleft * $element.width()) / timetotal;
  $element.find("div").animate({ width: progressBarWidth }, 500);
  if (timeleft > 0) {
    setTimeout(() => {
      progressBarTimer(timeleft - 1, timetotal, $element);
    }, 1000);
  }
};
export const secondsToHm = (d) => {
  d = Number(d);
  const h = Math.floor(d / 3600);
  const m = Math.floor((d % 3600) / 60);
  const s = Math.floor(d % 60);
  const newDate = new Date();
  newDate.setHours(h);
  newDate.setMinutes(m);
  newDate.setSeconds(s);
  return newDate;
};
export const changeTimezone = (date, ianatz) => {
  var invdate = new Date(
    date.toLocaleString("en-US", {
      timeZone: ianatz,
    })
  );
  var diff = date.getTime() - invdate.getTime();
  return new Date(date.getTime() - diff);
};

export const yyyymmdd = (date) => {
  var getYear = date.toLocaleString("default", { year: "numeric" });
  var getMonth = date.toLocaleString("default", { month: "2-digit" });
  var getDay = date.toLocaleString("default", { day: "2-digit" });

  return getYear + "-" + getMonth + "-" + getDay;
};
export const toISOLocal = (d) => {
  var z = (n) => ("0" + n).slice(-2);
  var zz = (n) => ("00" + n).slice(-3);

  return (
    d.getFullYear() +
    "-" +
    z(d.getMonth() + 1) +
    "-" +
    z(d.getDate()) +
    "T" +
    z(d.getHours()) +
    ":" +
    z(d.getMinutes()) +
    ":" +
    z(d.getSeconds()) +
    "." +
    zz(d.getMilliseconds()) +
    "Z"
  );
};
export const CustomPagination = (total, rowsPerPage, func) => {
  const count = Number(Math.ceil(total / rowsPerPage));
  return (
    <ReactPaginate
      previousLabel=""
      nextLabel=""
      pageRangeDisplayed={2}
      marginPagesDisplayed={2}
      pageCount={count || 1}
      breakLabel="..."
      activeClassName="active"
      breakClassName="page-item"
      breakLinkClassName="page-link"
      onPageChange={(page) => func(page)}
      pageClassName={"page-item"}
      nextLinkClassName={"page-link"}
      nextClassName={"page-item next"}
      previousClassName={"page-item prev"}
      previousLinkClassName={"page-link"}
      pageLinkClassName={"page-link"}
      containerClassName={"pagination react-paginate justify-content-end p-1"}
    />
  );
};
export const CustomSearchPagination = (
  total,
  rowsPerPage,
  initialPage,
  func
) => {
  const count = Number(Math.ceil(total / rowsPerPage));
  return (
    <ReactPaginate
      previousLabel=""
      nextLabel=""
      pageRangeDisplayed={2}
      marginPagesDisplayed={2}
      pageCount={count || 1}
      breakLabel="..."
      activeClassName="active"
      breakClassName="page-item"
      breakLinkClassName="page-link"
      forcePage={initialPage - 1}
      onPageChange={(page) => func(page)}
      pageClassName={"page-item"}
      nextLinkClassName={"page-link"}
      nextClassName={"page-item next"}
      previousClassName={"page-item prev"}
      previousLinkClassName={"page-link"}
      pageLinkClassName={"page-link"}
      containerClassName={"pagination react-paginate justify-content-end p-1"}
    />
  );
};
export const renderAlphabetic = (row) => {
  return (
    <Avatar
      color="light-success"
      width="36"
      height="36"
      className="me-1"
      content={row}
      initials
    />
  );
};
export const compareDates = (d1) => {
  let date1 = new Date(d1);
  let date2 = new Date(Date.now());
  if (date1 <= date2) {
    return true;
  } else if (date1 > date2) {
    return false;
  }
};

// ** Converts table to CSV
export const convertArrayOfObjectsToCSV = (array) => {
  let result;
  const columnDelimiter = ",";
  const lineDelimiter = "\n";
  const keys = array[0] && Object?.keys(array[0]);

  result = "";
  result += keys?.join(columnDelimiter);
  result += lineDelimiter;

  array.forEach((item) => {
    let ctr = 0;
    keys.forEach((key) => {
      if (ctr > 0) result += columnDelimiter;

      result += item[key];

      ctr++;
    });
    result += lineDelimiter;
  });

  return result;
};
export const downloadCSV = (array, title) => {
  const link = document.createElement("a");
  let csv = convertArrayOfObjectsToCSV(array);
  if (csv === null) return;

  const filename = `export-${title}.csv`;

  if (!csv.match(/^data:text\/csv/i)) {
    csv = `data:text/csv;charset=utf-8,${csv}`;
  }

  link.setAttribute("href", encodeURI(csv));
  link.setAttribute("download", filename);
  link.click();
};
export const exportPDF = (dataTab, headers, title) => {
  const unit = "pt";
  const size = "A4"; // Use A1, A2, A3 or A4
  const orientation = "portrait"; // portrait or landscape

  const marginLeft = 40;
  const doc = new jsPDF(orientation, unit, size);
  doc.setFontSize(15);
  doc.addFileToVFS("Amiri.ttf", arabicFont);
  doc.addFont("Amiri.ttf", "Amiri", "normal");
  doc.setFont("Amiri");

  const content = {
    startY: 100,
    head: headers,
    body: dataTab,
    bodyStyles: { font: "Amiri" },
  };

  doc.text(title, marginLeft, 40);
  doc.autoTable(content);
  doc.save(`${title}.pdf`);
};
export function escapeXmlTags(value) {
  if (value) {
    let escapedValue = value.replace(new RegExp("<", "g"), "&lt");
    escapedValue = escapedValue.replace(new RegExp(">", "g"), "&gt");
    return escapedValue;
  }
}
export function getDateString(jsonDate) {
  let when = new Date();
  if (jsonDate) {
    when = new Date(Date.parse(jsonDate));
  }
  let dateString =
    ("0" + when.getUTCHours()).slice(-2) +
    ":" +
    ("0" + when.getUTCMinutes()).slice(-2) +
    ":" +
    ("0" + when.getUTCSeconds()).slice(-2);
  return dateString;
}
